import { $ } from '@/libs/jquery/index'

export const baseSelector = '[data-selector="anchorTopArrow"]'

export class AnchorTop {
  private selectors: ISelectors = {
    base: baseSelector,
  }

  private base: JQuery

  constructor() {
    $(() => {
      this.base = $(this.selectors.base)

      if (this.base.length) {
        this.init()
      }
    })
  }

  public init(): void {
    this.checkArrowPosition()
    $(document).on('scroll', () => this.checkArrowPosition())
    this.base.on('click', (e) => {
      const targetBlock = this.base.attr('href')
      if (targetBlock.indexOf('#') !== -1) {
        e.preventDefault()
        const scrollTarget = $(targetBlock).offset().top - 80
        $('html, body').stop().animate({scrollTop: scrollTarget}, 700, 'linear')
      }
    })
  }

  private checkArrowPosition(): void {
    const documentScrollTop = $(document).scrollTop()
    const windowHeight = $(window).height() - 120

    if (documentScrollTop < windowHeight) {
      this.base.addClass('hidden')
    } else {
      this.base.removeClass('hidden')
    }
  }
}
